<div class="cnt-toast" #toast [ngClass]="type">
  <p>
    {{ text | translate: translationParams }}
  </p>
  <i class="material-icons close" *ngIf="close" (click)="closeToast()">close</i>
</div>
